import { render, staticRenderFns } from "./ProfilesForm.vue?vue&type=template&id=53d8ae5c&"
import script from "./ProfilesForm.vue?vue&type=script&lang=js&"
export * from "./ProfilesForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesForm.vue?vue&type=style&index=0&id=53d8ae5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports